 export const TipoAdministrador =
{
    "PorColaborador": {"Id": 1},
    "PorRol": {"Id": 2},
}

 export const FlujoDocumentoRequiereExtradata = {
    "si": {"Id": 1},
    "no": {"Id": 2},
}

 export const IdPlantillaDocumentoGenerico = 99999;

export const FlujoDocumentoScopeCampo = {
    "Unidad": {"Id": 1},
    "Cargo": {"Id": 2},
}

export const IdTipoDistribucion = {
    "PorFiltro": {"Id": 1},
    "ConCarga": {"Id": 2},
}

export const IdsPasos = {
     "Enviar" : {"Id":10},
     "ConfirmarRecepcion" : {"Id":11},
     "Observar" : {"Id":12},
     "Aprobar" : {"Id":13},
     "Aprobar2" : {"Id":14},
}

 export const IdsAcciones = {
     "EnvioToAprobar" : {"Id":10},
     "Completar" : {"Id":11},
     "SegundoAprobador" : {"Id":12},
     "Paso1" : {"Id":13}
 }

export const IdsDeOptionsValidosParaPaso1 = [IdsPasos.Enviar.Id, IdsPasos.ConfirmarRecepcion.Id]

